<template>
  <div class="card">
    <form id="budgetForm" class="form-horizontal">
      <div class="card-header">
        <h4 class="card-title">
          Budget Item Form
        </h4>
      </div>
      <div class="card-content">

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Budget Amount</label>
            <div class="col-sm-6">
              <input type="number"
                     name="amount"
                     data-vv-as="Amount"
                     v-validate="modelValidations.amount"
                     v-model="model.amount"
                     class="form-control">
              <small class="text-danger" v-show="amount.invalid">
                {{ getError('amount') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group column-sizing">
            <label class="col-sm-2 control-label">
              Category
            </label>
            <div class="col-sm-6">
              <el-select class="select-primary"
                           name="category"
                           data-vv-as="Category"
                           size="large"
                           placeholder="Choose One"
                           v-validate="modelValidations.category"
                           v-model="selects.categories">
                  <el-option v-for="option in selects.userBudgetCategories" 
                             class="select-primary"
                              :selected="option.label == selects.categories"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              <small class="text-danger" v-show="category.invalid">
                {{ getError('category') }}
              </small>
              
            </div>
          </div>
        </fieldset>
      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ model.saveBudgetButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
    },
    computed: {
      ...mapFields(['amount', 'category'])
    },
    data () {
      return {
        model: {
          amount: '',
          category: '',

          saveBudgetButtonText: 'Save Budget'
        },
        modelValidations: {
          category: {
            required: true
          },
          amount: {
            required: true,
            decimal: true
          },
        },
        selects: {
          categories: '',
          userBudgetCategories: []
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){
            this.model.category = this.selects.categories
            this.$emit('on-submit', this.model, isValid)
          }
        })
      },
      editViewCheck () {
        if(this.$route.name == 'Update Budget'){

          this.$http.get('/budgets/' + this.$route.params.id)
          .then(response => {
            var budgetDetails = response.data

            this.selects.categories = budgetDetails.category_id
            this.model.amount = budgetDetails.amount / 100
           
          })
          .catch(err => console.error(err))
          }
      },


      fetchCategories () {

        this.$http.get('/categories')
          
          .then(response => {
            let categories = response.data
            
            let categoriesToSelect = []

            for(let key = 0; key < categories.length; key++) {

              let selectOption = new Object
              selectOption.value = categories[key]['id']
              selectOption.label = categories[key]['name']
              
              categoriesToSelect[key] = selectOption
              
            }
            this.selects.userBudgetCategories = categoriesToSelect
            
          })
          .catch(err => console.error(err))
        
      }
    },

    mounted () {
      this.editViewCheck ()
      this.fetchCategories ()
    },

    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
<style>
  #budgetForm .el-select { display: block  !important;}
</style>
